const chubb_policy_URL =
  new Date().getFullYear() === 2020
    ? "https://cloudfront.bomapp.co.kr/bomapp_30/product/member/market/001/chubb_policy_v2.pdf"
    : "https://cloudfront.bomapp.co.kr/bomapp_30/product/member/market/001/chubb_policy.pdf";

export const hourSet = [
  { value: "00", label: "00시" },
  { value: "01", label: "01시" },
  { value: "02", label: "02시" },
  { value: "03", label: "03시" },
  { value: "04", label: "04시" },
  { value: "05", label: "05시" },
  { value: "06", label: "06시" },
  { value: "07", label: "07시" },
  { value: "08", label: "08시" },
  { value: "09", label: "09시" },
  { value: "10", label: "10시" },
  { value: "11", label: "11시" },
  { value: "12", label: "12시" },
  { value: "13", label: "13시" },
  { value: "14", label: "14시" },
  { value: "15", label: "15시" },
  { value: "16", label: "16시" },
  { value: "17", label: "17시" },
  { value: "18", label: "18시" },
  { value: "19", label: "19시" },
  { value: "20", label: "20시" },
  { value: "21", label: "21시" },
  { value: "22", label: "22시" },
  { value: "23", label: "23시" }
];

export const step0Text = {
  title: "후회없는\n여행을 위한 노하우,\nChubb 해외여행보험",
  desc: "여행 가실 때<br>걱정거리는 두고 가세요.",
  notice:
    '이 보험계약은 예금자보호법에 따라 예금보험공사가 보호하되, 보호한도는 본 보험회사에 있는 귀하의 모든 예금보호 대상 금융상품의 해약환급금 (또는 만기시 보험금이나 사고보험금)에 기타지급금을 합하여 1인당 "최고5천만원" 이며, 5천만원을 초과하는 나머지 금액은 보호하지 않습니다.<br>다만, 보험계약자 및 보험료 납부자가 법인인 보험계약은 예금자보호법에 따라 예금보험공사가 보호하지 않습니다.<br>보험계약자가 기존 보험계약을 해지하고 새로운 보험계약을 체결하는 경우 보험인수가 거절되거나 보험료가 인상될 수 있으며, 보장내용(면책기간 재적용 등)이 달라질 수 있습니다.<br>또한, 지급한도, 면책사항 등에 따라 보험금지급이 제한될 수 있습니다.계약 체결 전 자세한 상품내용은 약관 및 상품설명서를 참고하시기 바랍니다.',
  guaranteeContent: [
    {
      title: "해외여행시 다치거나 아플까봐 걱정된다면?",
      desc:
        "여행을 위해 집을 떠났을 때부터 여행을 마치고 집에 돌아올 때까지 발생한 상해사고와 질병을 보장해드립니다. (특약가입시)"
    },
    {
      title: "가방이나 소지품을 잃어버리면?",
      desc:
        "여행 중 소지한 휴대품의 도난 파손시, 가입금액 내 본인부담금 공제 후 보상하며 (특약가입시) 여권 재발행 비용도 보상합니다. (특약가입시)"
    },
    {
      title: "실수로 다른 사람에게 손해를 입혔다면?",
      desc:
        "우연한 사고로 다른 사람의 신체나 재산에 대한 피해를 보상합니다. 특약가입시 배상책임 담보로 보상합니다. (사고당 자기부담금 1만원, 특약가입시)"
    },
    {
      title: "말도 통하지 않는 해외에서 긴급상황이 발생했다면?",
      desc:
        "전 세계 어디서나 24시간 한국어 안내가 지원되는 Chubb Assistance 긴급지원서비스 센터 82-2-3449-3500로 연락주시면 의사/병원 안내, 긴급의료이송, 귀국수배, 유해본국송환 서비스 등을 도와드립니다."
    }
  ],
  chubbContent: [
    "보맵파트너는 보험계약자를 보맵으로, 보맵 회원을 피보험자 및 보험수익자로 하는 단체(취급) 여행보험계약을 체결할 수 있습니다. 단, 보험금의 종류가 사망보험금인 경우에는 그 보험수익자를 피보험자의 법정상속인으로 합니다.",
    "보험 계약의 수익자인 회원은 보맵에서 제공하는 서비스를 제공 받는 자로 정합니다.",
    "회원은 제1항의 보험계약에 따른 담보항목 및 내용을 보맵이 제공하는 범주 내에서 자유롭게 선택할 수 있으며 보험료를 직접 보맵에 납부하여야 합니다.",
    "제2항에 따라 보험회사에 보험료를 직접 납부한 회원은 계약자의 권리를 행사할 수 있습니다.",
    "보험계약에 관한 세부내용은 보험사가 제공하는 보험약관에 따릅니다.",
    "본 해외여행보험 서비스는 보맵 회원만 이용하실 수 있습니다."
  ]
};

export const stepText = {
  title_step1: "여행자보험 가입",
  title_step2: "보험료 확인",
  title_step3: "가입내용 확인 및 결제",
  title_popup_plan: "보장내용",
  desc_step1:
    "여행자보험, 이제 선택이 아닌 필수입니다.<br />도착할 때까지 든든히 지켜드립니다",
  desc_step2:
    "실속형, 표준형, 고급형 중 한 가지 플랜을 선택해주세요.<br />가입플랜을 선택하시면 보장내용을 확인하실 수 있습니다.",
  desc_step3:
    "보험 가입 정보를 확인해주세요.<br />입력하신 내용으로 보험 가입이 진행됩니다.",
  desc_popup_plan:
    "보장내역을 꼼꼼히 확인하세요<br />물음표를 클릭하시면 자세한 설명을 보실 수 있습니다."
};

export const alertText = {
  paymentCencel: {
    header: "결제 취소 안내",
    body: "보험 가입 결제가 취소되었습니다."
  },
  apiError: {
    header: "보험 가입 오류 안내",
    body:
      "보험 가입 과정에 오류가 발생하였습니다.\n보맵파트너 고객센터(1522-9657)에 문의해 주세요."
  },
  restrictedCountry: {
    header: "보험가입 제한 국가 안내",
    body: "선택하신 여행지는 보험가입이 제한된 국가입니다."
  },
  partialRestrictedCountry: {
    header: "보험가입 일부 제한 국가 안내",
    body: " 방문체류시 청약 불가능합니다."
  },
  accompanyMax: {
    header: "동반 가입자 초과 안내",
    body: "동반자는 최대 8명까지만 같이 가입할 수 있습니다."
  },
  removeAccompany: {
    header: "동반자 삭제 안내",
    body: "동반자를 삭제 하시겠습니까?"
  },
  overAge: {
    header: "해당 고객 가입 불가 안내",
    body: "101세 이상은 보험가입이 불가 합니다."
  },
  policyConfirm: {
    header: "중요 알림 내용 확인 안내",
    body:
      "안내된 내용을 모두 확인하셨나요?\n 안내 내용에 동의를 체크하셔야만 다음 단계로\n 이동할 수 있습니다"
  },
  overlap: {
    header: "중복가입 불가 안내",
    body: "이미 가입된 보험이 있습니다."
  },
  limitOneMonth: {
    header: "가입 불가 안내",
    body:
      "피보험자 연령 80세 이상의 경우 최대가입가능한 보험기간은 1개월 입니다."
  },
  samePerson: {
    header: "가입 불가 안내",
    body: "동반자 중 동일인이 있어 가입이 불가합니다."
  },
  withPartnerConfirm: {
    header: "동반가입 유의사항 확인 안내",
    body:
      "안내된 내용을 모두 확인하셨나요?\n 안내 내용에 동의를 체크하셔야만 다음 단계로\n 이동할 수 있습니다."
  },
  groupConfirm: {
    header: "단체가입 고지사항 확인 안내",
    body:
      "안내된 내용을 모두 확인하셨나요?\n 안내 내용에 동의를 체크하셔야만 다음 단계로\n 이동할 수 있습니다."
  },
  subscriptionEmpty: {
    header: "보험 가입내역 조회 안내",
    body: "가입된 내역이 없습니다."
  },
  subscriptionCodeNotMatch: {
    header: "정보 입력 안내",
    body: "휴대전화로 전송된 6자리 숫자를 정확하게 입력해주세요."
  },
  mobileRequest: {
    header: "정보 입력 안내",
    body: "인증번호 요청 후 진행해주세요."
  },
  englishCertificate: {
    header: "영문 가입증명서 발급 안내",
    body:
      "영문 가입증명서는 평일 10시~18시 사이에 \n발급받을 수 있습니다. (토, 일, 공휴일 제외)"
  },
  subscriptionError: {
    header: "결제가 완료되었습니다",
    body:
      "보험회사의 거절 사유가 없는 한 보험 청약은 영업시간(평일 10시~18시)에 처리됩니다."
  }
};

export const requireEnglishCertificateCountries = ["CZ", "BY", "EC"];

export const mainGuarantees = {
  title: "주 계약보험",
  v1: {
    data: [
      {
        title: "해외여행중 상해사망",
        desc:
          "해외여행 중에 상해의 직접결과로써 사망한 경우 보험가입금액 전액 지급"
      },
      {
        title: "해외여행중 상해후유장해",
        desc:
          "해외여행 중 상해로 장해분류표에서 정한 각 장해지급률에 해당하는 장해상태가 되었을 때 보험가입금액x지급률로 산출한 금액 지급\n" +
          "(장애 정도에 따라 보험가입금액의 3%~100% 지급) "
      }
    ]
  },
  v2: {
    data: [
      {
        title: "해외여행중 상해사망",
        desc:
          "해외여행 중에 상해의 직접결과로써 사망한 경우 보험가입금액 전액 지급"
      },
      {
        title: "해외여행중 상해후유장해",
        desc:
          "해외여행 중 상해로 장해분류표에서 정한 각 장해지급률에 해당하는 장해상태가 되었을 때 보험가입금액x지급률로 산출한 금액 지급\n" +
          "(장애 정도에 따라 보험가입금액의 3%~100% 지급) "
      }
    ]
  }
};

export const specialGuarantees = {
  title: "특약보험",
  v1: {
    data: [
      {
        title: "해외여행중 상해사망후유장해",
        desc:
          "해외여행 중에 상해의 직접결과로써 사망한 경우 보험가입금액 전액 지급"
      },
      {
        title: "해외여행중 상해후유장해",
        desc:
          "해외여행 중 상해로 장해분류표에서 정한 각 장해지급률에 해당하는 장해상태가 되었을 때 보험가입금액x지급률로 산출한 금액 지급\n" +
          "(장애 정도에 따라 보험가입금액의 3%~100% 지급) "
      },
      {
        title: "해외상해의료실비 (해외치료)",
        desc:
          "해외여행 중에 상해를 입고, 이로 인해 해외의료기관에서 의사(치료받는 국가의 법에서 정한 병원 및 의사의 자격을 가진 자에 한함)의 치료를 받은 때에는 보험가입금액을 한도로 피보험자가 실제 부담한 의료비 전액(단, 척추지압술, 침술의 경우 사고당 U$1,000 한도)을 보상. (치료를 받던 중 보험기간 만료시 종료일부터 180일 한도)"
      },
      {
        title: "해외상해의료실비 (국내입원)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관에서 입원 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음),국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)’의 90％ 해당액과 ‘비급여(본인이 실제로 부담한 금액)’의 80％해당액의 합한 금액(다만, 급여 중 본인부담금의 10％해당액과 비급여의 20％해당액을 합산한 금액이 계약일 또는 매년 계약해당일로부터 연간 200만원을 초과하는 경우 그 초과금액은 보상합니다.) 입원병실료 차액의 경우 50％를 공제한 후의 금액을 보상(단, 1일 평균 10만원 한도)"
      },
      {
        title: "해외상해의료실비 (국내통원외래)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관에서 통원치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 방문 1회당 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 의원급1만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합병원,전문병원급 1만5천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액원, 종합전문요양기관 및 상급종합병원 2만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 차감한 후 보험가입금액을 한도로 보상(보험기간 내 방문 180회 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 방문 90회 한도) "
      },
      {
        title: "해외상해의료실비 (국내통원처방조제)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관,약국에서 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA에 따른 처방조제비는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 처방조제비 건당 8천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 공제 후 보험가입금액을 한도로 보상(보험기간 내 처방전 180건 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 처방전 90건 한도) "
      },
      {
        title: "해외질병의료실비 (해외치료)",
        desc:
          "해외여행 중에 질병으로 인하여 해외의료기관에서 의사(치료받는 국가의 법에서 정한 병원 및 의사의 자격을 가진 자에 한함)의 치료를 받은 때에는 보험가입금액을 한도로 피보험자가 실제 부담한 의료비 전액(단, 척추지압술, 침술의 경우 질병당 U$1,000 한도)을 보상. (치료를 받던중 보험기간 만료시 종료일부터 180일 한도) "
      },
      {
        title: "해외질병의료실비 (국내입원)",
        desc:
          "해외여행 중에 질병으로 인하여 국내 의료기관에서 입원 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)’의 90％ 해당액과 ‘비급여(본인이 실제로 부담한 금액)’의 80％해당액의 합계액(다만, 급여 중 본인부담금의 10％해당액과 비급여의 20％해당액을 합산한 금액이 계약일 또는 매년 계약해당일로부터 연간 200만원을 초과하는 경우 그 초과금액은 보상합니다.) 입원병실료 차액의 경우 50％를 공제한 후의 금액을 보상(단, 1일 평균 10만원 한도) "
      },
      {
        title: "해외질병의료실비 (국내통원외래)",
        desc:
          "해외여행 중에 질병으로 인해 국내 의료기관에서 통원치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 방문 1회당 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 의원급1만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합병원,전문병원급 1만5천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합전문요양기관 및 상급종합병원 2만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 차감한 후 보험가입금액을 한도로 보상(보험기간 내 방문 180회 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 방문 90회 한도) "
      },
      {
        title: "해외질병의료실비 (국내통원처방조제)",
        desc:
          "해외여행 중에 질병으로 인해 국내 의료기관,약국에서 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA에 따른 처방조제비는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 처방조제비 건당 8천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 공제 후 보험가입금액을 한도로 보상(보험기간 내 처방전 180건 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 처방전 90건 한도) "
      },
      {
        title: "해외여행중 질병사망 및 질병 80%이상 후유장해",
        desc:
          "해외여행 도중에 질병으로 보험기간 중 또는 보험기간종료후 30일 이내에 사망하거나 장해지급률이 80％이상에 해당하는 장해상태가 되었을 때 가입금액 전액 보상 "
      },
      {
        title:
          "해외상해질병의료실비\n (특약_비급여 도수, 체외충격파,증식치료_국내치료)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 비급여「도수치료·체외충격파치료·증식치료」를 받은 경우 본인이 실제로 부담한 비급여 의료비(행위료, 약제비, 치료재료대 포함)에서 공제금액(1회당 2만원과 보상대상의료비의 30％ 중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 350만원 이내에서 도수치료·체외충격파치료·증식치료의 각 치료횟수를 합산하여 50회까지)내에서 보상 "
      },
      {
        title: "해외상해질병의료실비\n (특약_비급여 주사료_국내치료)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 주사치료를 받아 본인이 실제로 부담한 비급여 주사료에서 공제금액(입원, 통원 1회당 2만원과 보상대상의료비의 30％중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 250만원 이내에서 입원과 통원을 합산하여 50회까지)내에서 보상 "
      },
      {
        title: "해외상해질병의료실비\n (특약_비급여 MRI/MRA_국내치료)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 자기공명영상진단(MRI, MRA)을 받아 본인이 실제로 부담한 비급여 의료비(조영제, 판독료 포함)에서 공제금액(1회당 2만원과 보상대상의료비의 30％ 중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 연간 300만원 한도)내에서 보상 "
      },
      {
        title: "해외여행중 배상책임 (자기부담금 1만원)",
        desc:
          "해외여행도중에 생긴 우연한 사고로 타인의 신체의 장해 또는 재물의 손해에 대한 법률상의 배상책임을 부담함으로써 입은 손해를 보상(자기부담금1만원), 단 친족간 사고, 호텔이나 객실내의 동산을 제외한 피보험자가 소유, 사용 또는 관리하는 재물배상, 차량(원동력이 인력에 의한 것을 제외) 및 카트사고 등은 제외됩니다. (기타 약관참조) "
      },
      {
        title: "해외여행중 휴대품손해 (분실제외, 자기부담금 1만원)",
        desc:
          "해외여행도중에 생긴 우연한 사고에 의하여 보험의 목적(여행도중에 휴대하는 피보험자 소유,사용,관리의 휴대품)에 입은 손해를 보상함.(1회의 사고에 대하여 자기부담금 1만원을 공제한 금액으로 하며, 보험의 목적의 1개 또는 1조, 1쌍의 지급 보험금은 20만원(단, 이동통신단말기(공단말기 포함)에 대해서는 10만원(2020.1.1 가입건 부터 적용))을 한도로 함) ,단 통화, 신용카드, 항공권, 의치, 의수족, 콘택트렌즈 등은 제외하며 보험의 목적인 액체의 유출로 인한 사고 등은 제외됩니다 (기타 약관참조) "
      },
      {
        title: "해외여행중 중대사고 구조송환비용",
        desc:
          "해외여행도중에 피보험자가 탑승한 항공기, 선박의 행방불명, 조난 또는 피보험자가 사망하거나 14일 이상 입원할 경우 피보험자 또는 피보험자의 법정상속인이 부담하는 비용인 수색구조비용, 항공운임 등 교통비,숙박비, 이송비용, 제잡비를 약관이 정한 바에 따라 보상 "
      },
      {
        title: "신용카드사용액보상 (해외여행중 상해사망)",
        desc:
          "피보험자가 해외여행도중에 상해로 인하여 사망한 경우 보험가입금액 전액을 카드사용금액의 결제비용으로 보험수익자에게 지급"
      },
      {
        title: "해외여행중 여권분실후 재발급비용",
        desc:
          "피보험자가 해외여행 도중에 여권을 분실하거나 도난당하여 재외공간에 여권분실신고를 하고 여행증명서를 발급받은 경우, 여행증명서 발급비용과 여권재발급 비용을 보험수익자에게 지급 "
      },
      {
        title: "해외여행중 중단사고발생 추가비용",
        desc:
          '"피보험자가 해외여행 도중에 아래의 여행중단 사유 발생 이전에 귀국항공 또는 선박 운임비용 및 숙박비용을 미리 지급한 경우에 한하여 여행중단 사유 발생으로 여행을 중단하고 일정을 변경하여 귀국함으로서 미리 지급한 운임비용(항공 또는 선박) 및 숙박비용을 초과하여 피보험자에게 추가로 발생하는 운임비용(항공 또는 선박) 및 2박 이내의 숙박비용을 보험가입금액을 한도로 보상함 \n' +
          "＜여행중단 사유＞ \n" +
          "1. 피보험자 및 여행동반 가족이 상해 또는 질병으로 3일 이상 입원한 경우 \n" +
          "2. 피보험자의 3촌 이내의 친족 또는 여행동반자의 사망 \n" +
          '3. 지진, 분화, 해일 또는 이와 비슷한 천재지변, 전쟁, 외국의 무력행사, 혁명, 내란, 사변, 테러, 기타 이들과 유사한 사태 "'
      },
      {
        title: "항공기 및 수화물 지연에 따른 추가비용",
        desc:
          '"아래의 보험사고로 인하여 피보험자가 추가로 지출한 비용(아래 가. 나.의 경우 식사비, 숙박이 필요한 경우 숙박비, 다. 라.의 경우 비상의복과 생활필수품 구입비, 기타 약관 참조)에 대하여 1사고당 보험가입금액을 한도로 약관에 따라 보상(유료승객으로서 정기항공편을 이용한 경우에만 적용) \n' +
          "가. 연결항공편이 결항되어 실제 도착시간의 4시간 내에 피보험자에게 대체적인 항공운송수단이 제공되지 못할 경우 \n" +
          "나. 항공편이 4시간이상 지연, 취소되거나 또는 피보험자가 과적에 의해 탑승이 거부되어 예정시간으로부터 4시간 내에 대체적인 수단이 제공되지 못하는 경우 \n" +
          "다. 피보험자의 수화물이 항공편의 예정된 도착시간으로부터 6시간 이내에 도착하지 못하는 경우 \n" +
          '라. 피보험자의 수화물이 손실되거나 또는 피보험자가 목적지에 도착한 후 24시간 내에 등록된 수화물이 피보험자에게 도착하지 못하는 경우"'
      },
      {
        title: "해외여행중 식중독 입원일당 (4일이상 120일한도)",
        desc:
          "해외여행도중의 음식물 섭취로 인해 중독이 발생하고, 그 식중독의 치료를 직접적인 목적으로 4일 이상 입원치료를 받은 경우 3일 초과 1일당 식중독입원일당을 120일 한도로 지급. "
      },
      {
        title: "해외여행중 특정 전염병 치료비",
        desc:
          "해외여행도중에 특정전염병에 감염되어 특정전염병 환자로 진단받아 치료를 받을 경우 보험가입금액을 지급 "
      },
      {
        title: "해외여행중 상해입원일당 (4일이상 30일한도)",
        desc:
          "피보험자가 해외여행 도중에 상해를 입고 그 직접결과로써 생활기능 또는 업무능력에 지장을 가져와 병원 또는 의원(한방병원 또는 한의원을 포함)에 4일 이상 입원하여 의사의 치료를 받은 경우 3일 초과 입원 1일당 해외여행상해입원일당을 30일을 한도로 지급함 "
      },
      {
        title: "해외여행중 질병입원일당 (4일이상 30일한도)",
        desc:
          "피보험자가 해외여행 도중에 진단확정된 질병의 치료를 직접적인 목적으로 병원 또는 의원(한방병원 또는 한의원 포함)에 4일 이상 입원하여 의사의 치료를 받은 경우 3일 초과 입원 1일당 해외여행질병입원일당을 30일을 한도로 지급함 "
      },
      {
        title: "해외여행중 항공기납치",
        desc:
          "해외여행 도중에 피보험자가 탑승한 항공기가 납치됨에따라 예정목적지에 도착할 수 없게 된 동안 매일 70,000원씩 지급(항공기의 목적지 도착예정시간에서 12시간이 지난 이후부터 시작되는 24시간을 1일로 보아 20일을 한도)"
      }
    ]
  },
  v2: {
    data: [
      {
        title: "해외여행중 상해사망",
        desc:
          "해외여행 중에 상해의 직접결과로써 사망한 경우 보험가입금액 전액 지급"
      },
      {
        title: "해외여행중 상해후유장해",
        desc:
          "해외여행 중 상해로 장해분류표에서 정한 각 장해지급률에 해당하는 장해상태가 되었을 때 보험가입금액x지급률로 산출한 금액 지급\n" +
          "(장애 정도에 따라 보험가입금액의 3%~100% 지급) "
      },
      {
        title: "해외의료비(상해_해외여행실손)",
        desc:
          "해외여행 중에 상해를 입고, 이로 인해 해외의료기관에서 의사(치료받는 국가의 법에서 정한 병원 및 의사의 자격을 가진 자에 한함)의 치료를 받은 때에는 보험가입금액을 한도로 피보험자가 실제 부담한 의료비 전액(단, 척추지압술, 침술의 경우 사고당 U$1,000 한도)을 보상. (치료를 받던 중 보험기간 만료시 종료일부터 180일 한도)"
      },
      {
        title: "국내의료비(상해입원_해외여행실손)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관에서 입원 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음),국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)’의 90％ 해당액과 ‘비급여(본인이 실제로 부담한 금액)’의 80％해당액의 합한 금액(다만, 급여 중 본인부담금의 10％해당액과 비급여의 20％해당액을 합산한 금액이 계약일 또는 매년 계약해당일로부터 연간 200만원을 초과하는 경우 그 초과금액은 보상합니다.) 입원병실료 차액의 경우 50％를 공제한 후의 금액을 보상(단, 1일 평균 10만원 한도)"
      },
      {
        title: "국내의료비(상해통원외래_해외여행실손)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관에서 통원치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 방문 1회당 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 의원급1만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합병원,전문병원급 1만5천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액원, 종합전문요양기관 및 상급종합병원 2만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 차감한 후 보험가입금액을 한도로 보상(보험기간 내 방문 180회 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 방문 90회 한도) "
      },
      {
        title: "국내의료비(상해통원처방조제_해외여행실손)",
        desc:
          "해외여행 중에 상해를 입고 이로 인해 국내 의료기관,약국에서 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA에 따른 처방조제비는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 처방조제비 건당 8천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 공제 후 보험가입금액을 한도로 보상(보험기간 내 처방전 180건 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 처방전 90건 한도) "
      },
      {
        title: "해외의료비(질병_해외여행실손)",
        desc:
          "해외여행 중에 질병으로 인하여 해외의료기관에서 의사(치료받는 국가의 법에서 정한 병원 및 의사의 자격을 가진 자에 한함)의 치료를 받은 때에는 보험가입금액을 한도로 피보험자가 실제 부담한 의료비 전액(단, 척추지압술, 침술의 경우 질병당 U$1,000 한도)을 보상. (치료를 받던중 보험기간 만료시 종료일부터 180일 한도) "
      },
      {
        title: "국내의료비(질병입원_해외여행실손)",
        desc:
          "해외여행 중에 질병으로 인하여 국내 의료기관에서 입원 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)’의 90％ 해당액과 ‘비급여(본인이 실제로 부담한 금액)’의 80％해당액의 합계액(다만, 급여 중 본인부담금의 10％해당액과 비급여의 20％해당액을 합산한 금액이 계약일 또는 매년 계약해당일로부터 연간 200만원을 초과하는 경우 그 초과금액은 보상합니다.) 입원병실료 차액의 경우 50％를 공제한 후의 금액을 보상(단, 1일 평균 10만원 한도) "
      },
      {
        title: "국내의료비(질병통원외래_해외여행실손)",
        desc:
          "해외여행 중에 질병으로 인해 국내 의료기관에서 통원치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA는 보상하지 않음), 방문 1회당 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 의원급1만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합병원,전문병원급 1만5천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액, 종합전문요양기관 및 상급종합병원 2만원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 차감한 후 보험가입금액을 한도로 보상(보험기간 내 방문 180회 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 방문 90회 한도) "
      },
      {
        title: "해외질병의료실비(국내통원처방조제)",
        desc:
          "해외여행 중에 질병으로 인해 국내 의료기관,약국에서 치료를 받을 경우(단, 비급여 도수치료비, 체외충격파치료비, 증식치료비, 비급여주사료, 비급여 MRI/MRA에 따른 처방조제비는 보상하지 않음), 국민건강보험법에서 정한 요양급여 또는 의료급여법에서 정한 의료급여 중 본인부담금(본인이 실제로 부담한 금액)과 비급여부분의 합한 금액에서 처방조제비 건당 8천원과 공제기준금액(보상대상의료비의 급여 10％ 해당액과 비급여 20％ 해당액의 합산액)중 큰 금액을 공제 후 보험가입금액을 한도로 보상(보험기간 내 처방전 180건 한도, 단, 통원 치료중 보험기간 종료시 종료일 이후 180일까지 처방전 90건 한도) "
      },
      {
        title: "해외여행중 질병사망 및 질병 80%이상 후유장해",
        desc:
          "해외여행 도중에 질병으로 보험기간 중 또는 보험기간종료후 30일 이내에 사망하거나 장해지급률이 80％이상에 해당하는 장해상태가 되었을 때 가입금액 전액 보상 "
      },
      {
        title:
          "국내의료비(상해질병_해외여행실손_특약_비급여 도수, 체외충격파,증식치료)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 비급여「도수치료·체외충격파치료·증식치료」를 받은 경우 본인이 실제로 부담한 비급여 의료비(행위료, 약제비, 치료재료대 포함)에서 공제금액(1회당 2만원과 보상대상의료비의 30％ 중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 350만원 이내에서 도수치료·체외충격파치료·증식치료의 각 치료횟수를 합산하여 50회까지)내에서 보상 "
      },
      {
        title: "국내의료비(상해질병_해외여행실손_특약_비급여 주사료)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 주사치료를 받아 본인이 실제로 부담한 비급여 주사료에서 공제금액(입원, 통원 1회당 2만원과 보상대상의료비의 30％중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 250만원 이내에서 입원과 통원을 합산하여 50회까지)내에서 보상 "
      },
      {
        title: "국내의료비(상해질병_해외여행실손_특약_비급여 MRI/MRA)",
        desc:
          "해외여행 중에 입은 상해 또는 질병의 치료목적으로 국내 병원에 입원 또는 통원하여 자기공명영상진단(MRI, MRA)을 받아 본인이 실제로 부담한 비급여 의료비(조영제, 판독료 포함)에서 공제금액(1회당 2만원과 보상대상의료비의 30％ 중 큰 금액)을 뺀 금액을 보상한도(계약일부터 1년 단위로 연간 300만원 한도)내에서 보상 "
      },
      {
        title: "해외여행중 배상책임(자기부담금 1만원)",
        desc:
          "해외여행도중에 생긴 우연한 사고로 타인의 신체의 장해 또는 재물의 손해에 대한 법률상의 배상책임을 부담함으로써 입은 손해를 보상(자기부담금1만원), 단 친족간 사고, 호텔이나 객실내의 동산을 제외한 피보험자가 소유, 사용 또는 관리하는 재물배상, 차량(원동력이 인력에 의한 것을 제외) 및 카트사고 등은 제외됩니다. (기타 약관참조) "
      },
      {
        title: "해외여행중 휴대품손해(분실제외, 자기부담금 1만원)",
        desc:
          "해외여행도중에 생긴 우연한 사고에 의하여 보험의 목적(여행도중에 휴대하는 피보험자 소유,사용,관리의 휴대품)에 입은 손해를 보상함.(1회의 사고에 대하여 자기부담금 1만원을 공제한 금액으로 하며, 보험의 목적의 1개 또는 1조, 1쌍의 지급 보험금은 20만원(단, 이동통신단말기(공단말기 포함)에 대해서는 10만원(2020.1.1 가입건 부터 적용))을 한도로 함) ,단 통화, 신용카드, 항공권, 의치, 의수족, 콘택트렌즈 등은 제외하며 보험의 목적인 액체의 유출로 인한 사고 등은 제외됩니다 (기타 약관참조) "
      },
      {
        title: "해외여행중 중대사고 구조송환비용",
        desc:
          "해외여행도중에 피보험자가 탑승한 항공기, 선박의 행방불명, 조난 또는 피보험자가 사망하거나 14일 이상 입원할 경우 피보험자 또는 피보험자의 법정상속인이 부담하는 비용인 수색구조비용, 항공운임 등 교통비,숙박비, 이송비용, 제잡비를 약관이 정한 바에 따라 보상 "
      },
      {
        title: "신용카드사용액보상(해외여행중 상해사망)",
        desc:
          "피보험자가 해외여행도중에 상해로 인하여 사망한 경우 보험가입금액 전액을 카드사용금액의 결제비용으로 보험수익자에게 지급"
      },
      {
        title: "해외여행중 여권분실후 재발급비용",
        desc:
          "피보험자가 해외여행 도중에 여권을 분실하거나 도난당하여 재외공간에 여권분실신고를 하고 여행증명서를 발급받은 경우, 여행증명서 발급비용과 여권재발급 비용을 보험수익자에게 지급 "
      },
      {
        title: "해외여행중 중단사고발생 추가비용",
        desc:
          '"피보험자가 해외여행 도중에 아래의 여행중단 사유 발생 이전에 귀국항공 또는 선박 운임비용 및 숙박비용을 미리 지급한 경우에 한하여 여행중단 사유 발생으로 여행을 중단하고 일정을 변경하여 귀국함으로서 미리 지급한 운임비용(항공 또는 선박) 및 숙박비용을 초과하여 피보험자에게 추가로 발생하는 운임비용(항공 또는 선박) 및 2박 이내의 숙박비용을 보험가입금액을 한도로 보상함 \n' +
          "＜여행중단 사유＞ \n" +
          "1. 피보험자 및 여행동반 가족이 상해 또는 질병으로 3일 이상 입원한 경우 \n" +
          "2. 피보험자의 3촌 이내의 친족 또는 여행동반자의 사망 \n" +
          '3. 지진, 분화, 해일 또는 이와 비슷한 천재지변, 전쟁, 외국의 무력행사, 혁명, 내란, 사변, 테러, 기타 이들과 유사한 사태 "'
      },
      {
        title: "항공기 및 수화물 지연에 따른 추가비용",
        desc:
          '"아래의 보험사고로 인하여 피보험자가 추가로 지출한 비용(아래 가. 나.의 경우 식사비, 숙박이 필요한 경우 숙박비, 다. 라.의 경우 비상의복과 생활필수품 구입비, 기타 약관 참조)에 대하여 1사고당 보험가입금액을 한도로 약관에 따라 보상(유료승객으로서 정기항공편을 이용한 경우에만 적용) \n' +
          "가. 연결항공편이 결항되어 실제 도착시간의 4시간 내에 피보험자에게 대체적인 항공운송수단이 제공되지 못할 경우 \n" +
          "나. 항공편이 4시간이상 지연, 취소되거나 또는 피보험자가 과적에 의해 탑승이 거부되어 예정시간으로부터 4시간 내에 대체적인 수단이 제공되지 못하는 경우 \n" +
          "다. 피보험자의 수화물이 항공편의 예정된 도착시간으로부터 6시간 이내에 도착하지 못하는 경우 \n" +
          '라. 피보험자의 수화물이 손실되거나 또는 피보험자가 목적지에 도착한 후 24시간 내에 등록된 수화물이 피보험자에게 도착하지 못하는 경우"'
      },
      {
        title: "해외여행중 식중독 입원일당 (4일이상 120일한도)",
        desc:
          "해외여행도중의 음식물 섭취로 인해 중독이 발생하고, 그 식중독의 치료를 직접적인 목적으로 4일 이상 입원치료를 받은 경우 3일 초과 1일당 식중독입원일당을 120일 한도로 지급. "
      },
      {
        title: "해외여행중 특정 전염병 치료비",
        desc:
          "해외여행도중에 특정전염병에 감염되어 특정전염병 환자로 진단받아 치료를 받을 경우 보험가입금액을 지급 "
      },
      {
        title: "해외여행중 상해입원일당 (4일이상 30일한도)",
        desc:
          "피보험자가 해외여행 도중에 상해를 입고 그 직접결과로써 생활기능 또는 업무능력에 지장을 가져와 병원 또는 의원(한방병원 또는 한의원을 포함)에 4일 이상 입원하여 의사의 치료를 받은 경우 3일 초과 입원 1일당 해외여행상해입원일당을 30일을 한도로 지급함 "
      },
      {
        title: "해외여행중 질병입원일당 (4일이상 30일한도)",
        desc:
          "피보험자가 해외여행 도중에 진단확정된 질병의 치료를 직접적인 목적으로 병원 또는 의원(한방병원 또는 한의원 포함)에 4일 이상 입원하여 의사의 치료를 받은 경우 3일 초과 입원 1일당 해외여행질병입원일당을 30일을 한도로 지급함 "
      },
      {
        title: "해외여행중 항공기납치",
        desc:
          "해외여행 도중에 피보험자가 탑승한 항공기가 납치됨에따라 예정목적지에 도착할 수 없게 된 동안 매일 70,000원씩 지급(항공기의 목적지 도착예정시간에서 12시간이 지난 이후부터 시작되는 24시간을 1일로 보아 20일을 한도)"
      }
    ]
  }
};
// 관계자 플랜정보(PL101:실속형(0-14세), PL102:표준형(0-14세), PL103:고급형(0-14세),PL104:실속형(15-70세), PL105:표준형(15-70세), PL106:고급형(15-70세),PL107:실속형(71-79세), PL108:표준형(71-79세), PL109:실속형(80-100세)
const price301 = [
  "-",
  "1억원",
  "1,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "1,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "3000만원",
  "50만원",
  "3,000만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price302 = [
  "-",
  "2억원",
  "2,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "2,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "4,000만원",
  "100만원",
  "4,000만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price303 = [
  "-",
  "3억원",
  "3,000만원",
  "3,000만원",
  "25만원",
  "5만원",
  "3,000만원",
  "3,000만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "5,000만원",
  "150만원",
  "5,000만원",
  "-",
  "6만7천원",
  "50만원",
  "50만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price304 = [
  "1억원",
  "-",
  "1,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "1,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "3,000만원",
  "350만원",
  "250만원",
  "300만원",
  "3,000만원",
  "50만원",
  "3,000만원",
  "1,000만원",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price305 = [
  "2억원",
  "-",
  "2,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "2,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "4,000만원",
  "350만원",
  "250만원",
  "300만원",
  "4,000만원",
  "100만원",
  "4,000만원",
  "1,000만원",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price306 = [
  "3억원",
  "-",
  "3,000만원",
  "3,000만원",
  "25만원",
  "5만원",
  "3,000만원",
  "3,000만원",
  "25만원",
  "5만원",
  "5,000만원",
  "350만원",
  "250만원",
  "300만원",
  "5,000만원",
  "150만원",
  "5,000만원",
  "1,000만원",
  "6만7천원",
  "50만원",
  "50만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price307 = [
  "5,000만원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "20만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price308 = [
  "1억원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "50만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price309 = [
  "5,000만원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "20만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "-",
  "-",
  "-",
  "-",
  "140만원"
];

const price101 = [
  "-",
  "5,000만원",
  "1,000만원",
  "500만원",
  "25만원",
  "5만원",
  "1,000만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "40만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "10만원",
  "2만원",
  "20만원",
  "2만원",
  "2만원",
  "140만원"
];
const price102 = [
  "-",
  "1억원",
  "2,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "2,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "60만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "10만원",
  "2만원",
  "20만원",
  "2만원",
  "2만원",
  "140만원"
];
const price103 = [
  "-",
  "2억원",
  "3,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "3,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "1,000만원",
  "100만원",
  "1,000만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price104 = [
  "5,000만원",
  "-",
  "1,000만원",
  "500만원",
  "25만원",
  "5만원",
  "1,000만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "40만원",
  "300만원",
  "1,000만원",
  "6만7천원",
  "20만원",
  "10만원",
  "2만원",
  "20만원",
  "2만원",
  "2만원",
  "140만원"
];
const price105 = [
  "1억원",
  "-",
  "2,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "2,000만원",
  "1,000만원",
  "25만원",
  "5만원",
  "500만원",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "60만원",
  "300만원",
  "1,000만원",
  "6만7천원",
  "20만원",
  "10만원",
  "2만원",
  "20만원",
  "2만원",
  "2만원",
  "140만원"
];
const price106 = [
  "2억원",
  "-",
  "3,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "3,000만원",
  "2,000만원",
  "25만원",
  "5만원",
  "1,000만원",
  "350만원",
  "250만원",
  "300만원",
  "1,000만원",
  "100만원",
  "1,000만원",
  "1,000만원",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price107 = [
  "5,000만원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "20만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price108 = [
  "1억원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "50만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "2만원",
  "20만원",
  "3만원",
  "3만원",
  "140만원"
];
const price109 = [
  "5,000만원",
  "-",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "500만원",
  "500만원",
  "25만원",
  "5만원",
  "-",
  "350만원",
  "250만원",
  "300만원",
  "500만원",
  "20만원",
  "300만원",
  "-",
  "6만7천원",
  "20만원",
  "20만원",
  "-",
  "-",
  "-",
  "-",
  "140만원"
];

export const ageRange = {
  "1": {
    child: [
      {
        code: "PL101",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "1,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "40만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "10만원"
          }
        ],
        specialAmount: price101
      },
      {
        code: "PL102",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "2,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "60만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "10만원"
          }
        ],
        specialAmount: price102
      },
      {
        code: "PL103",
        type: "고급형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "3,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "100만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price103
      }
    ],
    general: [
      {
        code: "PL104",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "1,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "40만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "10만원"
          }
        ],
        specialAmount: price104
      },
      {
        code: "PL105",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "2,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "60만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "10만원"
          }
        ],
        specialAmount: price105
      },
      {
        code: "PL106",
        type: "고급형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "3,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "100만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price106
      }
    ],
    senior: [
      {
        code: "PL107",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "20만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price107
      },
      {
        code: "PL108",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "50만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price108
      },
      {
        code: "",
        type: "고급형",
        description: []
      }
    ],
    elder: [
      {
        code: "PL109",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "20만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price109
      },
      {
        code: "",
        type: "표준형",
        description: []
      },
      {
        code: "",
        type: "고급형",
        description: []
      }
    ]
  },
  "3": {
    child: [
      {
        code: "PL301",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "1,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "50만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price301
      },
      {
        code: "PL302",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "2,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "100만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price302
      },
      {
        code: "PL303",
        type: "고급형",
        description: [
          {
            item: "103-해외 상해 / 질병 해외 의료비",
            reward: "3,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "150만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "50만원"
          }
        ],
        specialAmount: price303
      }
    ],
    general: [
      {
        code: "PL304",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "1,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "50만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price304
      },
      {
        code: "PL305",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "2,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "100만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price305
      },
      {
        code: "PL306",
        type: "고급형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "3,000만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "150만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "50만원"
          }
        ],
        specialAmount: price306
      }
    ],
    senior: [
      {
        code: "PL307",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "20만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price307
      },
      {
        code: "PL308",
        type: "표준형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "50만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price308
      },
      {
        code: "",
        type: "고급형",
        description: []
      }
    ],
    elder: [
      {
        code: "PL309",
        type: "실속형",
        description: [
          {
            item: "해외 상해 / 질병 해외 의료비",
            reward: "500만원"
          },
          {
            item: "휴대품 손해(분실제외)",
            reward: "20만원"
          },
          {
            item: "항공기 / 수화물 지연비용",
            reward: "20만원"
          }
        ],
        specialAmount: price309
      },
      {
        code: "",
        type: "표준형",
        description: []
      },
      {
        code: "",
        type: "고급형",
        description: []
      }
    ]
  }
};

interface GuaranteeItemTypes {
  ages: string;
  name: string;
  type: string;
  guaranteeVersion: string;
  mainAmount: string[];
  specialAmount: string[];
}

interface GuaranteeValueTypes {
  PL101: GuaranteeItemTypes;
  PL102: GuaranteeItemTypes;
  PL103: GuaranteeItemTypes;
  PL104: GuaranteeItemTypes;
  PL105: GuaranteeItemTypes;
  PL106: GuaranteeItemTypes;
  PL107: GuaranteeItemTypes;
  PL108: GuaranteeItemTypes;
  PL109: GuaranteeItemTypes;
  PL201: GuaranteeItemTypes;
  PL202: GuaranteeItemTypes;
  PL203: GuaranteeItemTypes;
  PL204: GuaranteeItemTypes;
  PL205: GuaranteeItemTypes;
  PL206: GuaranteeItemTypes;
  PL207: GuaranteeItemTypes;
  PL208: GuaranteeItemTypes;
  PL209: GuaranteeItemTypes;
  PL301: GuaranteeItemTypes;
  PL302: GuaranteeItemTypes;
  PL303: GuaranteeItemTypes;
  PL304: GuaranteeItemTypes;
  PL305: GuaranteeItemTypes;
  PL306: GuaranteeItemTypes;
  PL307: GuaranteeItemTypes;
  PL308: GuaranteeItemTypes;
  PL309: GuaranteeItemTypes;
}

export const guaranteeValue: GuaranteeValueTypes = {
  PL301: {
    ages: "0~14세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["-", "1억원"],
    specialAmount: price301
  },
  PL302: {
    ages: "0~14세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["-", "2억원"],
    specialAmount: price302
  },
  PL303: {
    ages: "0~14세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v2",
    mainAmount: ["-", "3억원"],
    specialAmount: price303
  },
  PL304: {
    ages: "15~70세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["1억원", "-"],
    specialAmount: price304
  },
  PL305: {
    ages: "15~70세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["2억원", "-"],
    specialAmount: price305
  },
  PL306: {
    ages: "15~70세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v2",
    mainAmount: ["3억원", "-"],
    specialAmount: price306
  },
  PL307: {
    ages: "71~79세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["5천만원", "-"],
    specialAmount: price307
  },
  PL308: {
    ages: "71~79세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["1억원", "-"],
    specialAmount: price308
  },
  PL309: {
    ages: "80~100세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["5천만원", "-"],
    specialAmount: price309
  },
  PL201: {
    ages: "0~14세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v1",
    mainAmount: ["-", "1억원"],
    specialAmount: [
      "4000만원",
      "3000만원",
      "25만원",
      "5만원",
      "4000만원",
      "3000만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "70만원",
      "5000만원",
      "-",
      "6만7천원",
      "50만원",
      "60만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL202: {
    ages: "0~14세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v1",
    mainAmount: ["-", "2억원"],
    specialAmount: [
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "100만원",
      "5000만원",
      "-",
      "6만7천원",
      "50만원",
      "70만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL203: {
    ages: "0~14세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v1",
    mainAmount: ["-", "3억원"],
    specialAmount: [
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "150만원",
      "5000만원",
      "-",
      "6만7천원",
      "50만원",
      "80만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL204: {
    ages: "15~70세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v1",
    mainAmount: ["1억원", "-"],
    specialAmount: [
      "4000만원",
      "3000만원",
      "25만원",
      "5만원",
      "4000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "70만원",
      "5000만원",
      "1000만원",
      "6만7천원",
      "50만원",
      "60만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL205: {
    ages: "15~70세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v1",
    mainAmount: ["2억원", "-"],
    specialAmount: [
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "100만원",
      "5000만원",
      "1000만원",
      "6만7천원",
      "50만원",
      "70만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL206: {
    ages: "15~70세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v1",
    mainAmount: ["3억원", "-"],
    specialAmount: [
      "6000만원",
      "3000만원",
      "25만원",
      "5만원",
      "6000만원",
      "3000만원",
      "25만원",
      "5만원",
      "5000만원",
      "350만원",
      "250만원",
      "300만원",
      "5000만원",
      "150만원",
      "5000만원",
      "1000만원",
      "6만7천원",
      "50만원",
      "80만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL207: {
    ages: "71~79세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v1",
    mainAmount: ["1억원", "-"],
    specialAmount: [
      "500만원",
      "500만원",
      "25만원",
      "5만원",
      "500만원",
      "500만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "500만원",
      "30만원",
      "300만원",
      "-",
      "6만7천원",
      "30만원",
      "30만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL208: {
    ages: "71~79세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v1",
    mainAmount: ["1억원", "-"],
    specialAmount: [
      "1000만원",
      "500만원",
      "25만원",
      "5만원",
      "1000만원",
      "500만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "500만원",
      "50만원",
      "300만원",
      "-",
      "6만7천원",
      "30만원",
      "30만원",
      "2만원",
      "20만원",
      "3만원",
      "3만원",
      "140만원"
    ]
  },
  PL209: {
    ages: "80~100세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v1",
    mainAmount: ["5천만원", "-"],
    specialAmount: [
      "500만원",
      "500만원",
      "25만원",
      "5만원",
      "500만원",
      "500만원",
      "25만원",
      "5만원",
      "-",
      "350만원",
      "250만원",
      "300만원",
      "500만원",
      "20만원",
      "300만원",
      "-",
      "6만7천원",
      "20만원",
      "20만원",
      "-",
      "-",
      "-",
      "-",
      "140만원"
    ]
  },
  PL101: {
    ages: "0~14세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["-", "5,000만원"],
    specialAmount: price101
  },
  PL102: {
    ages: "0~14세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["-", "1억원"],
    specialAmount: price102
  },
  PL103: {
    ages: "0~14세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v2",
    mainAmount: ["-", "2억원"],
    specialAmount: price103
  },
  PL104: {
    ages: "15~70세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["5,000만원", "-"],
    specialAmount: price104
  },
  PL105: {
    ages: "15~70세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["1억원", "-"],
    specialAmount: price105
  },
  PL106: {
    ages: "15~70세",
    name: "고급형",
    type: "3",
    guaranteeVersion: "v2",
    mainAmount: ["2억원", "-"],
    specialAmount: price106
  },
  PL107: {
    ages: "71~79세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["5천만원", "-"],
    specialAmount: price107
  },
  PL108: {
    ages: "71~79세",
    name: "표준형",
    type: "2",
    guaranteeVersion: "v2",
    mainAmount: ["1억원", "-"],
    specialAmount: price108
  },
  PL109: {
    ages: "80~100세",
    name: "실속형",
    type: "1",
    guaranteeVersion: "v2",
    mainAmount: ["5천만원", "-"],
    specialAmount: price109
  }
};

export const policyContent = [
  {
    title: "개인(신용)정보의 수집, 이용에 관한 사항",
    url:
      "https://s3.ap-northeast-2.amazonaws.com/s3.bomapp.co.kr/bomapp_30_policy/market/chubb_travel_insurance/policy_1.html",
    value: "policy_1"
  },
  {
    title: "개인(신용)정보의 조회에 관한 사항",
    url:
      "https://s3.ap-northeast-2.amazonaws.com/s3.bomapp.co.kr/bomapp_30_policy/market/chubb_travel_insurance/policy_2.html",
    value: "policy_2"
  },
  {
    title: "개인(신용)정보의 제공에 관한 사항",
    url:
      "https://s3.ap-northeast-2.amazonaws.com/s3.bomapp.co.kr/bomapp_30_policy/market/chubb_travel_insurance/policy_3.html",
    value: "policy_3"
  },
  {
    title: "민감정보 및 고유식별정보의 처리에 관한 사항",
    url:
      "https://s3.ap-northeast-2.amazonaws.com/s3.bomapp.co.kr/bomapp_30_policy/market/chubb_travel_insurance/policy_4.html",
    value: "policy_4"
  }
];

export const chubbURL = {
  noticeURL:
    "https://www.acedirect.co.kr/servlets/common/commonForward.ace?target=mobile/products/out/notice01",
  policyURL: chubb_policy_URL,
  planURL: "https://www.acedirect.co.kr/jsp/directM/travel/travel.jsp"
};

export const bomappURL = {
  termsOfService:
    "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-terms-190801.html",
  pravicyPolicy:
    "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-policy-190801.html"
};

// 단체가입 고지사항
const groupNotice: string[] = [
  "마이리얼트립은 보험계약자를 마이리얼트립으로, 피보험자 및 보험수익자를 마이리얼트립이 제공하는 알선, 주최서비스의 제공을 받는자로 하는 단체(취급) 여행보험 계약을 체결 할 수 있습니다. 단, 보험금의 종류가 사망보험금인 경우에는 그 보험수익자를 피보험자의 법정상속인으로 합니다.",
  "1)의 보험계약에 따른 담보항목 및 내용을 마이리얼트립이 제공하는 범주내에서 자유롭게 선택할 수 있으며 보험료를 직접 보험대리점에 납부하여야 합니다.",
  "2)에 따라 보험료를 보험대리점에 직접 납부 시 계약자의 권리를 행사할 수 있습니다.",
  "보험계약에 관한 세부내용은 보험사가 제공하는 보험약관에 따릅니다."
];

// 가입전 유의사항
const beforeJoinNotice: string[] = [
  "이 보험계약은 예금자보호법에 따라 예금보험공사가 보호하되, 보호한도는 본 보험회사에 있는 귀하의 모든 예금보호 대상 금융상품의 해약환급금(또는 만기시 보험금이나 사고보험금)에 기타지급금을 합하여 1인당 “최고5천만원” 이며, 5천만원을 초과하는 나머지 금액은 보호하지 않습니다. 다만, 보험계약자 및 보험료 납부자가 법인인 보험계약은 예금자보호법에 따라 예금보험공사가 보호하지 않습니다. 보험계약자가 기존 보험계약을 해지하고 새로운 보험계약을 체결하는 경우 보험인수가 거정되거나 보험료 인상될 수 있으며, 보장내용(면책기간 재적용 등)이 달라질 수 있습니다. 또한, 지급한도, 면책사항 등에 따라 보험금지급이 제한될 수 있습니다. 계약 체결 전 자세한 상품내용은 약관 및 상품설명서를 참고하시기 바랍니다."
];

const withPartnerNotice: string[] = [
  "본인은 본 보험계약의 피보험자로 되는 것에 동의하며, 만일 본인이 타 여행객을 대신하여 보험 가입절차를 이행하는 경우 본인은 여행계약 체결에 대하여 타 여행객으로부터 적법하게 대리권을 수여 받았음을 확인합니다. \n 만약 대리권이 존재하지 않는 경우, 그 범위 내에서 단체보험계약이 일부 무효로 되거나 보험사고시 보험금 지급이 거절될 수 있다는 점을 충분히 이해 하였습니다. \n 본인은 본 보험계약의 피보험자로 되는 것에 동의하며, 만일 본인이 타 여행객을 대신하여 보험 가입절차를 이행하는 경우 본인은 여행계약 체결에 대하여 타 여행객으로부터 적법하게 대리권을 수여 받았음을 확인합니다. \n 만약 대리권이 존재하지 않는 경우, 그 범위 내에서 단체보험계약이 일부 무효로 되거나 보험사고시 보험금 지급이 거절될 수 있다는 점을 충분히 이해 하였습니다."
];

export interface AgreementType {
  title: string;
  descType: string;
  desc?: any;
  link?: string;
  checked?: boolean;
}

export const agreementGroup: AgreementType = {
  title: "Chubb 해외여행보험\n 단체가입 고지사항",
  descType: "link",
  link:
    "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/travel/policy/group-terms.html"
};

export const agreementGroupPC: AgreementType = {
  title: "Chubb 해외여행보험\n 단체가입 고지사항",
  descType: "popup",
  desc: groupNotice
};

export const agreementBeforeJoin: AgreementType = {
  title: "Chubb 해외여행보험\n 가입 전 유의사항",
  descType: "popup",
  desc: beforeJoinNotice
};

export const agreementList: AgreementType[] = [
  {
    title: "동반 가입시 유의사항",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/travel/policy/with-partner-terms.html",
    checked: false
  },
  {
    title: "보험약관",
    descType: "pdf",
    link: chubb_policy_URL,
    checked: false
  },
  {
    title: "유의사항",
    descType: "link",
    link:
      "https://www.acedirect.co.kr/servlets/common/commonForward.ace?target=mobile/products/out/notice01",
    checked: false
  },
  {
    title: "서비스 이용약관",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-terms-190801.html",
    checked: false
  },
  {
    title: "개인정보 수집 및 이용 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-personal-191001.html",
    checked: false
  },
  {
    title: "개인정보 조회에 대한 동의(보험회사)",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-inquiry-191001.html",
    checked: false
  },
  {
    title: "고유식별정보 수집 및 이용 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-indentification-191001.html",
    checked: false
  },
  {
    title: "개인정보의 제3자 제공 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-third-party-191001.html",
    checked: false
  }
];

export const agreementListPC: AgreementType[] = [
  {
    title: "동반 가입시 유의사항",
    descType: "popup",
    desc: withPartnerNotice,
    checked: false
  },
  {
    title: "보험약관",
    descType: "link",
    link: chubb_policy_URL,
    checked: false
  },
  {
    title: "유의사항",
    descType: "link",
    link:
      "https://www.acedirect.co.kr/servlets/common/commonForward.ace?target=mobile/products/out/notice01",
    checked: false
  },
  {
    title: "서비스 이용약관",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-terms-190801.html",
    checked: false
  },
  {
    title: "개인정보 수집 및 이용 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-personal-191001.html",
    checked: false
  },
  {
    title: "개인정보 조회에 대한 동의(보험회사)",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-inquiry-191001.html",
    checked: false
  },
  {
    title: "고유식별정보 수집 및 이용 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-indentification-191001.html",
    checked: false
  },
  {
    title: "개인정보의 제3자 제공 동의",
    descType: "link",
    link:
      "https://cloudfront.bomapp.co.kr/bomapp_30_b2b2c/policy/agree-third-party-191001.html",
    checked: false
  }
];
